export default "__VITE_ASSET__C2z_pi$E__"